import { Component } from '@angular/core';

@Component({
    selector: 'app-settings-navigation',
    templateUrl: './settings-navigation.component.html',
    styleUrl: './settings-navigation.component.scss',
    standalone: false
})
export class SettingsNavigationComponent {

}
